import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import { DateService } from '@atlas/core';

const getTime = () => {
  const now = dayjs();

  return DateService.getFormattedTime(now);
};

const HeaderClock = () => {
  const [time, setTime] = useState(getTime());
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(getTime());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    // fix if needed
    <div className="time">
      <span>{time}</span>
    </div>
  );
};

export default HeaderClock;
